import { parseFormNumber } from "Components/Analyses/Budget/parseFormNumber";
import { type IncomeAmountAmountType, IncomeIncomeType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, lazy, mixed, object, string } from "yup";

export type IncomeDraft = {
  /** Set once the income is saved. */
  readonly guid?: string;
  readonly incomeType: IncomeIncomeType;
  readonly clientGuid: string;
  readonly amountType: IncomeAmountAmountType;
  readonly amountValue: string;
  /** Only the other income has a name. */
  readonly name: string;
  /** One row of a saved income with several amounts - shown, but never edited or saved. */
  readonly isReadOnly?: boolean;
};

export type IncomeBulkFormType = {
  readonly drafts: IncomeDraft[];
};

export const getIncomeBulkFormSchema = (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
): ObjectSchema<IncomeBulkFormType> => {
  const required = t(Resources.Validation.Required);

  return object({
    drafts: array()
      .of(
        lazy((draft: IncomeDraft) => {
          if (draft.isReadOnly) {
            return mixed();
          }

          return object({
            clientGuid: string().required(required),
            amountType: string().required(required),
            amountValue: string()
              .required(required)
              .test("more-than-zero", t(Resources.Validation.Number.MoreThen, { count: 0 }), (value) => parseFormNumber(value) > 0),
            name: draft.incomeType === IncomeIncomeType.other ? string().trim().required(required) : string(),
          });
        }),
      )
      .required(),
  }) as ObjectSchema<IncomeBulkFormType>;
};
